export default __webpack_public_path__ + "static/media/ethereum-eth.df265e36.svg";